import React from 'react'

export default function iframe() {
  return (
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3306.7440541332335!2d-4.997691084936051!3d34.02478018061346!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd9f8b6b7ad8d659%3A0x17b883b0340ac6fc!2sESISA!5e0!3m2!1sfr!2sma!4v1628544723692!5m2!1sfr!2sma" width="100%" height="700" style={{border:0}} allowfullscreen="" loading="lazy"></iframe>

  )
}
